import { apiRequest } from "../auth/api";

export interface PublicTaxonomyAlias {
  value: string;
  locale: string;
}

export interface PublicTaxonomyItem {
  id: string;
  namespace: string;
  code: string;
  slug: string;
  nameVi: string;
  nameEn: string | null;
  parentId: string | null;
  sortOrder: number;
  metadata: Record<string, unknown>;
  aliases: PublicTaxonomyAlias[];
}

export interface PublicTaxonomyNamespace {
  code: string;
  nameVi: string;
  nameEn: string | null;
  descriptionVi: string | null;
  sortOrder: number;
  supportsHierarchy: boolean;
}

export function getTaxonomyNamespaces() {
  return apiRequest<{ namespaces: PublicTaxonomyNamespace[] }>(
    "/api/v1/taxonomy/namespaces",
  );
}

export function searchPublicTaxonomy(
  namespace: string,
  input: { query?: string; cursor?: string | null; limit?: number; parentId?: string | null } = {},
) {
  const params = new URLSearchParams();
  if (input.query) params.set("q", input.query);
  if (input.cursor) params.set("cursor", input.cursor);
  if (input.limit) params.set("limit", String(input.limit));
  if (input.parentId) params.set("parentId", input.parentId);
  return apiRequest<{
    items: PublicTaxonomyItem[];
    nextCursor: string | null;
    total: number;
  }>(`/api/v1/taxonomy/${encodeURIComponent(namespace)}?${params.toString()}`);
}
